import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReportGatewayService {
  constructor(private http: HttpClient) { }

  getLookupData(reportID, paramName, paramData) {
    let url = "/ReportGateway/GetLookupData";
    return this.http.post(url, {
      reportID: reportID, paramName: paramName, paramData: paramData
    }).toPromise();
  }

  getReports(reportID, moduleShortName, company = null) {
    let url = "/ReportGateway/GetReports" + (reportID != null ? ("?reportID=" + reportID) : "") + (moduleShortName != null ? ("?moduleShortName=" + moduleShortName) : "") + (company != null ? ("&company=" + company) : "");
    return this.http.get(url).toPromise();
  }

  loadReport(Params, ReportID, PorOrLan, fileType, ReportName) {
    let url = "/ReportGateway/LoadReport";
    return this.http.post(url, {
      Params: Params, ReportID: ReportID, PorOrLan: PorOrLan, fileType: fileType, ReportName: ReportName
    }).toPromise();
  }

  setParamCache(params) {
    return this.http.post("/ReportGateway/SetParamCache", { rptParams: params }).toPromise();
  }

  reportTrack(reportID, reportName, params) {
    return this.http.post("/ReportGateway/ReportTrack", { reportID: reportID, reportName: reportName, reportParams: params}).toPromise();
  }

  getVistaAttachment(attachmentId, rid, rsid) {
    let url = "/ReportGateway/GetVistaAttachment?attachmentId=" + attachmentId + "&rid=" + rid + "&rsid=" + rsid;
    return this.http.get(url).toPromise();
  }
}
